import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_743k1dnnoa: FaireBrandEntity = {
  token: "b_743k1dnnoa",
  type: "brand",
  name: "Strong N Free",
  location: "Victoria, BC, Canada",
  isTopShop: true,
  meta: {
    source: "snowflake",
    importedAt: "2026-09-25T00:00:00.000Z",
    importedBy: "real-brand-data",
  },
};
